{
  "level": "ab00",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ab00",
    "objects": "AREAS.E3:ab00.e3",
    "mesh": "TREES.E3:ab00.e3"
  },
  "spawn_point": {
    "position": [
      -3459.8783783783783,
      -4959.8399097339525,
      1055.70703125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3459.8783783783783,
      -4859.8399097339525,
      1055.70703125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3475.0,
      -5018.20068359375,
      1031.70703125
    ],
    "bbox_max": [
      -3430.0,
      -4900.00048828125,
      1096.70703125
    ],
    "vertex_count": 37,
    "vertices": [
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -4971.00048828125,
        1096.70703125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      [
        -3463.0,
        -4900.00048828125,
        1041.70703125
      ],
      [
        -3473.0,
        -4900.00048828125,
        1041.70703125
      ],
      [
        -3463.0,
        -4909.00048828125,
        1041.70703125
      ],
      [
        -3463.0,
        -4900.00048828125,
        1041.70703125
      ],
      [
        -3473.0,
        -4909.00048828125,
        1041.70703125
      ],
      [
        -3463.0,
        -4909.00048828125,
        1041.70703125
      ],
      [
        -3473.0,
        -4909.00048828125,
        1041.70703125
      ],
      [
        -3473.0,
        -4900.00048828125,
        1041.70703125
      ],
      [
        -3460.0,
        -5001.00048828125,
        1086.3736572265625
      ],
      [
        -3459.5,
        -5001.00048828125,
        1086.3736572265625
      ],
      [
        -3460.0,
        -5001.00048828125,
        1093.70703125
      ],
      [
        -3475.0,
        -5001.00048828125,
        1093.70703125
      ],
      [
        -3463.0,
        -4900.00048828125,
        1096.70703125
      ],
      [
        -3463.0,
        -4909.00048828125,
        1096.70703125
      ],
      [
        -3473.0,
        -4909.00048828125,
        1096.70703125
      ],
      [
        -3473.0,
        -4900.00048828125,
        1096.70703125
      ],
      [
        -3465.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3471.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3471.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3475.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3460.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3465.0,
        -4989.00048828125,
        1093.70703125
      ],
      [
        -3471.0,
        -4989.00048828125,
        1092.0999755859375
      ],
      [
        -3465.0,
        -4989.00048828125,
        1092.0999755859375
      ],
      [
        -3460.0,
        -5013.92919921875,
        1031.70703125
      ],
      [
        -3460.0,
        -5013.92919921875,
        1041.70703125
      ],
      [
        -3473.0,
        -4910.00048828125,
        1041.70703125
      ],
      [
        -3473.0,
        -4910.00048828125,
        1031.70703125
      ],
      [
        -3463.0,
        -4910.00048828125,
        1041.70703125
      ],
      [
        -3463.0,
        -4910.00048828125,
        1031.70703125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -3.3881499916788016e-07,
        0.8881831765174866,
        0.4594896137714386
      ],
      "plane_d": 3958.270751953125,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3428.964111328125,
        -5016.20068359375,
        1085.572998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5001.00048828125,
      "bbox_min": [
        -3460.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -5001.00048828125,
        1086.3736572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5001.00048828125,
      "bbox_min": [
        -3460.0,
        -5001.00048828125,
        1086.3736572265625
      ],
      "bbox_max": [
        -3459.5,
        -5001.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.70703125,
      "bbox_min": [
        -3475.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3460.0,
        -4900.0,
        1108.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1096.70703125,
      "bbox_min": [
        -3475.0,
        -5001.00048828125,
        1093.70703125
      ],
      "bbox_max": [
        -3460.0,
        -4900.00048828125,
        1108.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -5105.30419921875,
      "bbox_min": [
        -3473.0,
        -4990.00048828125,
        1089.70703125
      ],
      "bbox_max": [
        -3471.0,
        -4989.00048828125,
        1093.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": -5028.66357421875,
      "bbox_min": [
        -3473.0,
        -4911.00048828125,
        1089.70703125
      ],
      "bbox_max": [
        -3471.0,
        -4910.00048828125,
        1093.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4989.25,
      "bbox_min": [
        -3471.0,
        -4989.25,
        1091.699951171875
      ],
      "bbox_max": [
        -3465.0,
        -4988.74951171875,
        1093.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.0999755859375,
      "bbox_min": [
        -3471.0,
        -4989.00048828125,
        1092.0999755859375
      ],
      "bbox_max": [
        -3465.0,
        -4988.74951171875,
        1092.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.0999755859375,
      "bbox_min": [
        -3471.0,
        -4989.25,
        1092.0999755859375
      ],
      "bbox_max": [
        -3465.0,
        -4989.00048828125,
        1092.0999755859375
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}